import { IMenuItem } from "./IMenuItem";

export function addTrackingToNavigation(navigation: IMenuItem[]): IMenuItem[] {
  let depth = 0,
    universe = "";

  navigation.forEach((menuItem: IMenuItem) => {
    universe = menuItem.title;
    iterateMenu(menuItem, depth, universe);
  });

  return navigation;
}

function iterateMenu(menuItem: IMenuItem, depth: number, universe: string) {
  menuItem.tracking = _generateNavTrackingText(menuItem.title, depth, universe);
  if (menuItem.children) {
    menuItem.children.forEach((menuItem: IMenuItem) => {
      iterateMenu(menuItem, depth + 1, universe);
    });
  }
}

export function _generateNavTrackingText(
  title: string,
  depth: number,
  universe: string
): string {
  return `fly:${
    depth === 0 ? "for home" : universe
  }:l${depth}:${title.trim()}`.toLowerCase();
}
